import React from 'react';
import { Interactable, Icon, Checkbox } from 'LocalGluons';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import styles from './EditSelectBar.jss';

const EditSelectBar = ({ editing, loading, refreshing, allCheckbox, selectAll, startEditing }) => (
    <View style={styles.editContainer}>
        {editing ? (
            <Interactable
                testID="select_all_button"
                style={styles.editTouchArea}
                onPress={selectAll}
                disabled={loading || refreshing}
            >
                <Checkbox
                    // key is required here to control checked state from parent
                    key={allCheckbox ? 'selected' : 'empty'}
                    onPress={selectAll}
                    checked={allCheckbox}
                    style={styles.selectAllCheckbox}
                />
                <Text style={styles.selectAllText}>{t('RECORDINGS.SELECT_ALL')}</Text>
            </Interactable>
        ) : (
            <Interactable
                testID="edit_button"
                style={styles.editTouchArea}
                onPress={startEditing}
                hitSlop={{ top: 0, left: 15, right: 0, bottom: 0 }}
                disabled={loading || refreshing}
            >
                <Text style={styles.editText}>{t('COMMON.EDIT')}</Text>
                <Icon style={styles.editIcon} name="edit" />
            </Interactable>
        )}
    </View>
);

EditSelectBar.propTypes = {
    editing: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    refreshing: PropTypes.bool.isRequired,
    allCheckbox: PropTypes.bool.isRequired,
    selectAll: PropTypes.func.isRequired,
    startEditing: PropTypes.func.isRequired
};

export default EditSelectBar;
